import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe as NgCurrencyPipe } from '@angular/common';

@Pipe({
  name: 'appCurrency'
})
export class CurrencyPipe implements PipeTransform {
  private readonly defaultCurrencyCode = undefined;
  private readonly defaultDisplay = 'symbol-narrow';
  private readonly defaultDigitsInfo = '1.2';
  private readonly currencyPipe: NgCurrencyPipe;

  constructor() {
    this.currencyPipe = inject(NgCurrencyPipe);
  }

  public transform(...[
    value,
    currencyCode = this.defaultCurrencyCode,
    display = this.defaultDisplay,
    digitsInfo = this.defaultDigitsInfo,
    locale
  ]: Parameters<NgCurrencyPipe['transform']>): any {
    if (value === null || value === undefined || (typeof value === 'string' && isNaN(Number(value))) || (typeof value === 'number' && isNaN(value))) {
      return '-';
    }
    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
  }
}
